import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import Vuelidate from 'vuelidate';
import 'vant/lib/index.css';
import './common/scss/common.scss';
import 'lib-flexible'

Vue.use(Vant);
Vue.use(Vuelidate);
Vue.config.productionTip = false
Vue.prototype.$global = {
    url: ''
}
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
